
import img0 from './Images/InstallMacOS_1.png';
import img1 from './Images/InstallMacOS_2.png';
import img2 from './Images/InstallMacOS_3.png';
import img3 from './Images/InstallMacOS_4.png';
  
const content = `# Install SecureFile on MacOS
  
The OnData SecureFile software for MacOS comes with two installation packages: \`OnDataSecureFile_osx-arm64_<version>.pkg\` for the ARM64-based Apple 
processors, and \`OnDataSecureFile_osx-x64_<version>.pkg\` for the Intel x64 processors. Please download the appropriate package based on your process architecture.  
  
After obtaining the release package from OnData, you can run the installation package to install the SecureFile product. Please note that administrative access 
to the operating system is required to install the OnData SecureFile product.  
  
Below is the list of steps to install the product on MacOS.  
a. Ensure you have logged in with an administrative account to your computer and you do not have any other applications running.  
  
b. Double click on the installation package file and an \`Introduction\` screen will be displayed.  
  
![Introduction Screen](${ img0 })  
  
c. Select \`Continue\` to continue. On the next screen you can choose \`Customize\` to select a disk drive where the application should be installed. It is recommended 
to use the default option.  
  
![Installation Type](${ img1 })  

d. Click on the \`Install\` button and the system will prompt you to use your Touch ID or enter your password to allow for the installation.  
  
![Permission for Installation](${ img2 })  
  
e. The installation process will start and run till completion. At the end of the installation, the following screen is displayed. Click on the \`Close\` button to 
complete the installation process.     
  
![Summary Screen](${ img3 })  
  
**Note**: If your computer does not have the Microsoft .NET Runtime 8.x installed, it may automatically install the Microsoft .NET Runtime 8.x component.  
  
f. After the SecureFile product is installed, you can proceed to the instructions in [Register SecureFile](reference_doc#securefile/installation_and_configuration/register_securefile) to register 
your SecureFile instance with the OnData Portal.  
  
  `
  
export default content;
